import Vue from 'vue'
import Router from "vue-router";
import Userauth from '../auth/js/index'
import { authHeader } from '../_helpers/auth-header'

import Body from '../components/body'
import Auth from '../auth/auth'
import { userService } from '../_services';

// import { store } from '../store'

// import VueJwtDecode from "vue-jwt-decode";

// import SamplePage from '../pages/sample_page'
import Dashboard from '../pages/dashboard'
import Setting from '../pages/setting'
import Slider from '../pages/sliders'

/* Auth */
import Login from '../auth/login'
import Register from '../auth/register'
// import callback from '../pages/callback'

/* Patient */
// import PatientList from '../pages/patient/patientlist'
import Alert from '../pages/alerts/alert'
import AlertReport from '../pages/alerts/alertreport'
import ShopList from '../pages/shop/shoplist'
import ShopReport from '../pages/shop/shopreport'
import CustomerList from '../pages/customer/customerlist'
import CustomerReport from '../pages/customer/customerreport'
// import PatientReport from '../pages/patient/patientreport'
import VisitList from '../pages/visit/visitlist'
import VisitReport from '../pages/visit/visitreport'
import PreferenceList from '../pages/preference/preferencelist'
import PreferenceReport from '../pages/preference/preferencereport'
import ReviewList from '../pages/review/reviewlist'
import ReviewReport from '../pages/review/reviewreport'
import ProductList from '../pages/product/productlist'
import ProductReport from '../pages/product/productreport'


import SummaryReport from '../pages/reports/summary';
import reportReport from '../pages/reports/report';

/* User */
import adduser from '../auth/adduser'

/* Medication */
// import AllMedication from '../pages/medication/allmedication'
// import AllDrugs from '../pages/medication/alldrugs'


/* Prescription */
import Prescriptions from '../pages/prescription/prescriptions'
import InsuranceProvider from '../pages/prescription/insurance'
import Prescriber from '../pages/prescription/prescriber'
import AllPrescriptionReport from '../pages/prescription/allprescriptionsreport'
import courierList from '../pages/couriers/courierlist.vue'
import orderList from '../pages/orders/orderlist.vue'
import orderReport from '../pages/orders/orderreport.vue'

// component

Vue.use(Router)

const routes = [
  { path: '', redirect: { name: 'dashboard' }},
  { path: '/', redirect: { name: 'dashboard' }},
  { path: '/setting', redirect: { name: 'setting' }},
  { path: '/sliders', redirect: { name: 'slider' }},
  {
    path: '/dashboard',
    component: Body,
    children: [
    {
      path: 'default',
      name: 'dashboard',
      component: Dashboard,
      meta: {
        title: 'Default Dashboard',
      }
    }
    ]
  },
  {
    path: '/setting',
    name: 'setting',
    component: Body,
    children: [
    {
      path: '',
      name: 'setting',
      component: Setting,
      meta: {
        title: 'Setting',
      }
    }
    ]
  },
  {
    path: '/sliders',
    name: 'Sliders',
    component: Body,
    children: [
    {
      path: '',
      name: 'slider',
      component: Slider,
      meta: {
        title: 'Slider',
      }
    }
    ]
  },
  {
    path: '/auth',
    component: Auth,
    children: [
      {
        path: 'login',
        name: 'login',
        component: Login,
        meta: {
          title: 'Auth | Login',
        }
      },
      {
        path: 'register',
        name: 'register',
        component: Register,
        meta: {
          title: 'Auth | Register',
        }
      },
      {
        path: 'forgotpassword',
        name: 'forgot-password',
        component: Login,
        meta: {
          title: 'Auth | Login',
        }
      }
    ]
  },
  {
    path: '/user',
    component: Body,
    children: [
      {
        path: 'adduser',
        name: 'adduser',
        component: adduser,
        meta: {
          title: 'User | Add User',
        }
      },
      {
        path: 'resetuser',
        name: 'resetuser',
        component: adduser,
        meta: {
          title: 'User | Reset User',
        }
      },
      {
        path: 'changepassword',
        name: 'changepassword',
        component: adduser,
        meta: {
          title: 'User | Change Password',
        }
      }
    ]
  },
  {
    path: '/alerts',
    component: Body,
    children: [
      {
        path: 'alert',
        name: 'alert',
        component: Alert,
        meta: {
          title: 'Alert ',
        }
      },
      {
        path: 'alertreport',
        name: 'alert-report',
        component: AlertReport,
        meta: {
          title: 'Alert Report',
        }
      }
    ]
  },
  {
    path: '/shop',
    component: Body,
    children: [
      {
        path: 'shoplist',
        name: 'shop-list',
        component: ShopList,
        meta: {
          title: 'Shop List',
        }
      },
      {
        path: 'shopreport',
        name: 'shop-report',
        component: ShopReport,
        meta: {
          title: 'Shop Report',
        }
      }
    ]
  },
  {
    path: '/customer',
    component: Body,
    children: [
      {
        path: 'customerlist',
        name: 'customer-list',
        component: CustomerList,
        meta: {
          title: 'Customer List',
        }
      },
      {
        path: 'customerreport',
        name: 'customer-report',
        component: CustomerReport,
        meta: {
          title: 'Customer Report',
        }
      }
    ]
  },
  {
    path: '/couriers',
    component: Body,
    children: [
      {
        path: 'courierlist',
        name: 'courier-list',
        component: courierList,
        meta: {
          title: 'Courier List',
        }
      }
    ]
  },
  {
    path: '/orders',
    component: Body,
    children: [
      {
        path: 'orderlist',
        name: 'order-list',
        component: orderList,
        meta: {
          title: 'Order List',
        }
      },
      {
        path: 'orderreport',
        name: 'order-report',
        component: orderReport,
        meta: {
          title: 'Order Report',
        }
      }
    ]
  },
  {
    path: '/visit',
    component: Body,
    children: [
      {
        path: 'visitlist',
        name: 'visit-list',
        component: VisitList,
        meta: {
          title: 'Visit List',
        }
      },
      {
        path: 'visitreport',
        name: 'visit-report',
        component: VisitReport,
        meta: {
          title: 'Visit Report',
        }
      }
    ]
  },
  {
    path: '/review',
    component: Body,
    children: [
      {
        path: 'reviewlist',
        name: 'review-list',
        component: ReviewList,
        meta: {
          title: 'Review List',
        }
      },
      {
        path: 'reviewreport',
        name: 'review-report',
        component: ReviewReport,
        meta: {
          title: 'Review Report',
        }
      }
    ]
  },
  {
    path: '/preference',
    component: Body,
    children: [
      {
        path: 'preferencelist',
        name: 'preference-list',
        component: PreferenceList,
        meta: {
          title: 'Preference List',
        }
      },
      {
        path: 'preferencereport',
        name: 'preference-report',
        component: PreferenceReport,
        meta: {
          title: 'Preference Report',
        }
      }
    ]
  },
  {
    path: '/reports',
    component: Body,
    children: [
      {
        path: 'summary',
        name: 'summary',
        component: SummaryReport,
        meta: {
          title: 'Summary Report',
        }
      },
      {
        path: 'report',
        name: 'report',
        component: reportReport,
        meta: {
          title: 'Report',
        }
      }
    ]
  },
  {
    path: '/product',
    component: Body,
    children: [
      {
        path: 'productlist',
        name: 'product-list',
        component: ProductList,
        meta: {
          title: 'Product List',
        }
      },
      {
        path: 'productreport',
        name: 'product-report',
        component: ProductReport,
        meta: {
          title: 'Product Report',
        }
      }
    ]
  },
  {
    path: '/prescription',
    component: Body,
    children: [
      {
        path: 'prescriptions',
        name: 'prescriptions',
        component: Prescriptions,
        meta: {
          title: ' Prescriptions',
        }
      },
      {
        path: 'prescriber',
        name: 'prescriber',
        component: Prescriber,
        meta: {
          title: ' Prescriber Details',
        }
      },
      {
        path: 'insurance',
        name: 'insurance',
        component: InsuranceProvider,
        meta: {
          title: ' Insurance Provider',
        }
      },
      {
        path: 'allprescriptionsreport',
        name: 'allprescriptions-report',
        component: AllPrescriptionReport,
        meta: {
          title: 'Prescriptions | Report',
        }
      }
    ]
  },
];

const router = new Router({
  routes,
  base: '/',
  mode: 'history',
  linkActiveClass: "active",
  scrollBehavior () {
    return { x: 0, y: 0 }
  }
});


// configure axios 
const axios = require('axios')

// token
let token = authHeader()['Authorization']

// window.axios= axios.create({
//   baseURL: `http://localhost:4000/api/`,
//   headers: {
//     Authoization: `Bearer ${token}`
//   }
// })

// set default 
axios.defaults.baseURL = 'https://sc.imeonlyne.com/v1/'
// axios.defaults.baseURL = 'http://localhost:8000/v1'
axios.defaults.headers.common['Authorization'] = token

// authenticate 
router.beforeEach((to, from, next) => {
    
    // user
    const User = localStorage.getItem('user')

    if (['/auth/login','/auth/register'].includes(to.path) || (User && Userauth.isAuthenticated())){
      return next();
    } else {
      //
      // user
      const User = JSON.parse(localStorage.getItem('user'))
      // validate
      if (!User) {
          return next('/auth/login')
      }
      // initiate a refresh request
      userService.refresh(User.refresh_token).then(()=>{
          //
          if (['/auth/login','/auth/register'].includes(to.path) || (User && Userauth.isAuthenticated())) {
              return next();
          }

      }).catch( ()=>{
          //
          Userauth.logOut()
          //
          return next('/auth/login')
       })
    }

    // check token expiry
    
    // decode jwt token
    // axios.get('/user').then( () => {
    //   // token is valid
    //   // console.log(res.data)
    //   const User = localStorage.getItem('user')

    //   const  path = ['/auth/login','/auth/register'];
    //   if (path.includes(to.path) || to.path === "/callback" || User || Userauth.isAuthenticatedUser()){
    //     return next();
    //   }
      
    //   next('/auth/login')

    // })
    // .catch( () => {
    //   // initiate a refresh request
    //   store.dispatch("authentication/refresh", { token, refresh_token })
    //   // wait
    //   setTimeout(() =>{

    //     if (store.state.authentication.status.refreshedToken == true ){

    //       const User = localStorage.getItem('user')

    //       if (['/auth/login','/auth/register'].includes(to.path) || to.path === "/callback" || User || Userauth.isAuthenticatedUser()){
    //         return next();
    //       }
          
    //       next('/auth/login')
    //     }
        
    //     // set new token
    //     // axios.defaults.headers.common['Authorization'] = authHeader()['Authorization']
        
    //   }, 450)
    // })

    // if(to.meta.title)
      // document.title = to.meta.title;

    
});


export default router
